import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../pages/index.vue'
import Error404 from '../pages/Error404.vue'

import Vol01 from '../pages/Vol01.vue'
import Vol02 from '../pages/Vol02.vue'
import Vol03 from '../pages/Vol03.vue'
import Vol04 from '../pages/Vol04.vue'
import Vol05 from '../pages/Vol05.vue'
import Vol06 from '../pages/Vol06.vue'

import Promo2018 from '../pages/Promo2018.vue'

import Jewel01 from '../pages/Jewel01.vue'
import Jewel02 from '../pages/Jewel02.vue'
import Jewel03 from '../pages/Jewel03.vue'
import Jewel04 from '../pages/Jewel04.vue'
import Jewel04_Ange from '../pages/Jewel04_Ange.vue'
import Jewel05 from '../pages/Jewel05.vue'
import Jewel05_Anna from '../pages/Jewel05_Anna.vue'
import Jewel05_Daia from '../pages/Jewel05_Daia.vue'
import Jewel05_Nico from '../pages/Jewel05_Nico.vue'
import Jewel06 from '../pages/Jewel06.vue'
import Jewel06_Emo from '../pages/Jewel06_Emo.vue'
import Jewel06_Dia from '../pages/Jewel06_Dia.vue'
import Jewel06_Nico from '../pages/Jewel06_Nico.vue'
import JewelCoords from '../pages/JewelCoords.vue'

import PritickeGummy  from '../pages/PritickeGummy.vue'
import PristaPack     from '../pages/PristaPack.vue'
import PritickePack01 from '../pages/PritickePack01.vue'
import PritickePack02 from '../pages/PritickePack02.vue'
import PritickePack03 from '../pages/PritickePack03.vue'
import KiraKiraPack01 from '../pages/KiraKiraPack01.vue'
import KiraKiraPack02 from '../pages/KiraKiraPack02.vue'
import KiraKiraPack03 from '../pages/KiraKiraPack03.vue'
import PritickePack07 from '../pages/PritickePack07.vue'

import Promo2019_Toys   from '../pages/Promo2019_Toys.vue'
import Promo2019_Perif  from '../pages/Promo2019_Perif.vue'
import Promo2019_Pact   from '../pages/Promo2019_Pact.vue'
import Promo2019_Events from '../pages/Promo2019_Events.vue'

import PriTama01      from '../pages/PriTama01.vue'
import PriTama01_Nico from '../pages/PriTama01_Nico.vue'
import PriTama02      from '../pages/PriTama02.vue'
import PriTama02_Nico from '../pages/PriTama02_Nico.vue'
import PriTama03      from '../pages/PriTama03.vue'
import PriTama03_Nico from '../pages/PriTama03_Nico.vue'
import PriTama04      from '../pages/PriTama04.vue'
import PriTama04_Nico from '../pages/PriTama04_Nico.vue'
import PriTama05      from '../pages/PriTama05.vue'
import PriTama05_Core from '../pages/PriTama05_Core.vue'
import PriTama05_Nico from '../pages/PriTama05_Nico.vue'
import PriTama06      from '../pages/PriTama06.vue'
import PriTama06_Core from '../pages/PriTama06_Core.vue'
import PriTama06_Nico from '../pages/PriTama06_Nico.vue'

import Promo2020      from '../pages/Promo2020.vue'
import Promo2020_Ptgo from '../pages/Promo2020_Ptgo.vue'

import PAF01      from '../pages/PAF01.vue'
import PAF01_Core from '../pages/PAF01_Core.vue'
import PAF02      from '../pages/PAF02.vue'
import PAF02_Core from '../pages/PAF02_Core.vue'
import PAF03      from '../pages/PAF03.vue'
import PAF03_Core from '../pages/PAF03_Core.vue'

import Promo2021 from '../pages/Promo2021.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    { group: '2021', path: '/PAF01'     , name: 'オルフレ1弾'        , component: PAF01     , capability: 1 },
    { group: '2021', path: '/PAF01/Core', name: 'オルフレ1弾［Core］', component: PAF01_Core, capability: 0 },
    { group: '2021', path: '/PAF02'     , name: 'オルフレ2弾'        , component: PAF02     , capability: 1 },
    { group: '2021', path: '/PAF02/Core', name: 'オルフレ2弾［Core］', component: PAF02_Core, capability: 0 },
    { group: '2021', path: '/PAF03'     , name: 'オルフレ3弾'        , component: PAF03     , capability: 1 },
    { group: '2021', path: '/PAF03/Core', name: 'オルフレ3弾［Core］', component: PAF03_Core, capability: 0 },

    { group: 'プロモ2021', path: '/Promo2021', name: 'プロモ2021［いろいろ］', component: Promo2021, capability: 1 },

    { group: '2020', path: '/PriTama01'     , name: 'プリたま1弾'             , component: PriTama01     , capability: 1 },
    { group: '2020', path: '/PriTama01/Nico', name: 'プリたま1弾［ニコチケ］' , component: PriTama01_Nico, capability: 0 },
    { group: '2020', path: '/PriTama02'     , name: 'プリたま2弾'             , component: PriTama02     , capability: 1 },
    { group: '2020', path: '/PriTama02/Nico', name: 'プリたま2弾［ニコチケ］' , component: PriTama02_Nico, capability: 0 },
    { group: '2020', path: '/PriTama03'     , name: 'プリたま3弾'             , component: PriTama03     , capability: 1 },
    { group: '2020', path: '/PriTama03/Nico', name: 'プリたま3弾［ニコチケ］' , component: PriTama03_Nico, capability: 0 },
    { group: '2020', path: '/PriTama04'     , name: 'プリたま4弾'             , component: PriTama04     , capability: 1 },
    { group: '2020', path: '/PriTama04/Nico', name: 'プリたま4弾［ニコチケ］' , component: PriTama04_Nico, capability: 0 },
    { group: '2020', path: '/PriTama05'     , name: 'プリたま5弾'             , component: PriTama05     , capability: 1 },
    { group: '2020', path: '/PriTama05/Core', name: 'プリたま5弾［Core］'     , component: PriTama05_Core, capability: 0 },
    { group: '2020', path: '/PriTama05/Nico', name: 'プリたま5弾［ニコチケ］' , component: PriTama05_Nico, capability: 0 },
    { group: '2020', path: '/PriTama06'     , name: 'プリたま6弾'             , component: PriTama06     , capability: 1 },
    { group: '2020', path: '/PriTama06/Core', name: 'プリたま6弾［Core］'     , component: PriTama06_Core, capability: 0 },
    { group: '2020', path: '/PriTama06/Nico', name: 'プリたま6弾［ニコチケ］' , component: PriTama06_Nico, capability: 0 },

    { group: 'プロモ2020', path: '/Promo2020/Ptgo', name: 'プロモ2020［プリたまGO連動］', component: Promo2020_Ptgo, capability: 1 },
    { group: 'プロモ2020', path: '/Promo2020'     , name: 'プロモ2020［いろいろ］'      , component: Promo2020     , capability: 1 },

    { group: '2019', path: '/Jewel01'     , name: 'ジュエル1弾'                , component: Jewel01     , capability: 1 },
    { group: '2019', path: '/Jewel02'     , name: 'ジュエル2弾'                , component: Jewel02     , capability: 1 },
    { group: '2019', path: '/Jewel03'     , name: 'ジュエル3弾'                , component: Jewel03     , capability: 1 },
    { group: '2019', path: '/Jewel04'     , name: 'ジュエル4弾'                , component: Jewel04     , capability: 1 },
    { group: '2019', path: '/Jewel04/Ange', name: 'ジュエル4弾［アンジュ］'    , component: Jewel04_Ange, capability: 0 },
    { group: '2019', path: '/Jewel05'     , name: 'ジュエル5弾'                , component: Jewel05     , capability: 1 },
    { group: '2019', path: '/Jewel05/Anna', name: 'ジュエル5弾［あんな］'      , component: Jewel05_Anna, capability: 0 },
    { group: '2019', path: '/Jewel05/Daia', name: 'ジュエル5弾［だいあ］'      , component: Jewel05_Daia, capability: 0 },
    { group: '2019', path: '/Jewel05/Nico', name: 'ジュエル5弾［ニコチケ］'    , component: Jewel05_Nico, capability: 0 },
    { group: '2019', path: '/Jewel06'     , name: 'ジュエル6弾'                , component: Jewel06     , capability: 1 },
    { group: '2019', path: '/Jewel06/Emo' , name: 'ジュエル6弾［えも］'        , component: Jewel06_Emo , capability: 0 },
    { group: '2019', path: '/Jewel06/Dia' , name: 'ジュエル6弾［ダイヤモンド］', component: Jewel06_Dia , capability: 0 },
    { group: '2019', path: '/Jewel06/Nico', name: 'ジュエル6弾［ニコチケ］'    , component: Jewel06_Nico, capability: 0 },
    { group: '2019', path: '/JewelCoords' , name: 'ジュエルコーデ'             , component: JewelCoords , capability: 1 },

    { group: 'プロモ2019', path: '/Promo2019/Toys'  , name: 'プロモ2019［おもちゃ系］'        , component: Promo2019_Toys  , capability: 1 },
    { group: 'プロモ2019', path: '/Promo2019/Perif' , name: 'プロモ2019［周辺商品系］'        , component: Promo2019_Perif , capability: 1 },
    { group: 'プロモ2019', path: '/Promo2019/Pact'  , name: 'プロモ2019［ジュエルパクト連動］', component: Promo2019_Pact  , capability: 1 },
    { group: 'プロモ2019', path: '/Promo2019/Events', name: 'プロモ2019［イベント系］'        , component: Promo2019_Events, capability: 1 },

    { group: '2018', path: '/Vol01', name: '第1弾', component: Vol01, capability: 1 },
    { group: '2018', path: '/Vol02', name: '第2弾', component: Vol02, capability: 1 },
    { group: '2018', path: '/Vol03', name: '第3弾', component: Vol03, capability: 1 },
    { group: '2018', path: '/Vol04', name: '第4弾', component: Vol04, capability: 1 },
    { group: '2018', path: '/Vol05', name: '第5弾', component: Vol05, capability: 1 },
    { group: '2018', path: '/Vol06', name: '第6弾', component: Vol06, capability: 1 },

    { group: 'プロモ2018', path: '/Promo2018', name: 'プロモ2018［いろいろ］', component: Promo2018, capability: 1 },

    { group: 'プリチケパック／グミ', path: '/PritickeGummy' , name: 'プリチケコレクショングミ'              , component: PritickeGummy , capability: 1 },
    { group: 'プリチケパック／グミ', path: '/PristaPack'    , name: 'プリスタパック'                        , component: PristaPack    , capability: 1 },
    { group: 'プリチケパック／グミ', path: '/PritickePack01', name: 'プリチケパック1'                       , component: PritickePack01, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/PritickePack02', name: 'プリチケパック2'                       , component: PritickePack02, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/PritickePack03', name: 'プリチケパック3'                       , component: PritickePack03, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/KiraKiraPack01', name: 'キラキラパック［ミラクル☆キラッツ編］', component: KiraKiraPack01, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/KiraKiraPack02', name: 'キラキラパック［メルティックスター編］', component: KiraKiraPack02, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/KiraKiraPack03', name: 'キラキラパック［オールアイドル編］'    , component: KiraKiraPack03, capability: 1 },
    { group: 'プリチケパック／グミ', path: '/PritickePack07', name: 'プリチケパック［プリたま編Vol.1］'     , component: PritickePack07, capability: 1 },


    { group: null, path: '*.vue'    , redirect: to => to.path.split('.')[0]  , capability: 0 },
    { group: null, path: '/(index)?', name: 'Top Page' , component: Index    , capability: 0 },
    { group: null, path: '*'        , name: 'Error 404', component: Error404 , capability: 0 },
  ],

  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
})
